export const startEditing = (name, id) => ({
  type: `${name}_EDIT_STARTED`,
  payload: id,
});

export const stopEditing = (name, id) => ({
  type: `${name}_EDIT_STOPPED`,
  payload: id,
});
